"use client";

import { useEffect, useState } from "react";
import { Bell } from "lucide-react";

interface NotificationToastProps {
	message: string;
	type: "chat" | "admin";
	onClick?: () => void;
}

export function NotificationToast({
	message,
	type,
	onClick,
}: NotificationToastProps) {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
		}, 5000);

		return () => clearTimeout(timer);
	}, []);

	if (!isVisible) return null;

	return (
		<div
			className="flex items-center gap-2 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
			onClick={onClick}
		>
			<Bell className="w-5 h-5 text-blue-500" />
			<div className="flex-1">
				<p className="text-sm font-medium text-gray-900 dark:text-gray-100">
					{type === "chat" ? "New Message" : "Admin Notification"}
				</p>
				<p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
			</div>
		</div>
	);
}
